<template>
  <div class="p-payments mt-4 pa-2 mx-auto">
    <VcPayments />
  </div>
</template>

<style lang="scss">
.p-payments {
  width: 800px;
  max-width: 800px;
}
</style>
